import { Landmark, Copy } from "lucide-react";
import { toast } from "sonner";

const copyValue = async (label, value) => {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`${label} copied`);
  } catch { /* clipboard unavailable */ }
};

const BankRow = ({ label, value, testId }) => (
  <div className="flex justify-between items-center gap-3 py-1.5">
    <span className="text-gray-500 text-xs">{label}</span>
    <button
      type="button"
      data-testid={testId}
      onClick={() => copyValue(label, value)}
      className="font-mono-tab text-sm font-medium flex items-center gap-1.5 hover:text-[#F48E2E] transition-colors"
    >
      {value} <Copy className="h-3 w-3 text-gray-400" />
    </button>
  </div>
);

export default function BankTransferInstructions({ order, testIdPrefix = "bank-transfer" }) {
  const bd = order?.bank_details;
  if (!order || order.payment_method !== "bank_transfer" || order.payment_status === "paid" || !bd?.account_number) return null;
  const ref = (order.id || "").slice(0, 8).toUpperCase();
  return (
    <div data-testid={`${testIdPrefix}-panel`} className="mt-5 rounded-xl border border-dashed border-[#F48E2E]/60 bg-orange-50/60 p-4 text-left">
      <div className="flex items-center gap-2 mb-2">
        <Landmark className="h-4 w-4 text-[#F48E2E]" />
        <span className="font-semibold text-sm">Bank Transfer Instructions</span>
      </div>
      <p className="text-xs text-gray-600 mb-2">
        Transfer <strong>₹{Number(order.total || 0).toLocaleString("en-IN")}</strong> to the account below. Your order is confirmed once we receive the payment.
      </p>
      <div className="divide-y divide-orange-100">
        <BankRow label="Account Holder" value={bd.account_holder_name} testId={`${testIdPrefix}-holder`} />
        <BankRow label="Bank" value={bd.bank_name} testId={`${testIdPrefix}-bank`} />
        <BankRow label="Account Number" value={bd.account_number} testId={`${testIdPrefix}-account`} />
        <BankRow label="IFSC" value={bd.ifsc} testId={`${testIdPrefix}-ifsc`} />
        <BankRow label="Reference" value={ref} testId={`${testIdPrefix}-reference`} />
      </div>
    </div>
  );
}
